import React, { useState } from "react";
/// React router dom
import { Switch, Route, Redirect } from "react-router-dom";
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";
import "../css/theme.css";
/// Layout
import Nav from "./layouts/nav";

/// Deshboard
import Home from "./components/Dashboard/Home/Home";
import BuyNFM from "./components/Dashboard/Home/BuyNFM";

/// Pages

import ThankYou from "./pages/Thankyou";
import Terms from "./pages/Terms";

//Scroll To Top
import ScrollToTop from "./layouts/ScrollToTop";
// import IframeLoader from "./components/IframeLoader";
import MyCollection from "./components/Dashboard/Home/MyCollection";
import MyRewards from "./components/Dashboard/Home/MyRewards";

import GenesisModePage from "./components/Dashboard/Home/GenesisModePage";
// import Staking from "./components/Dashboard/Home/Staking";
import Footer from "./layouts/Footer";
import Privacy from "./pages/Privacy";
import EmiPayment from "./components/Dashboard/Home/EmiPayment";

const Markup = () => {
	let path = window.location.pathname;
	path = path.split("/");
	path = path[path.length - 1];
	let pagePath = path.split("-").includes("page");
	const [activeEvent, setActiveEvent] = useState(!path);

	const iframeRoutes = ["staking"];

	console.log(path, pagePath, activeEvent, "path pagepath activeEvent");

	const routes = [
		/// Dashboard
		{ url: "", component: Home },
		{ url: "dashboard", component: Home },
		{ url: "buy-nfm", component: BuyNFM },
		{ url: "emi", component: EmiPayment },
		{ url: "my-collection", component: MyCollection },
		{ url: "my-rewards", component: MyRewards },
		// {url: "staking", component: Staking},
		{ url: "genesis-node", component: GenesisModePage },
		{ url: "genesis-mode-page", component: GenesisModePage },

		{ url: "thank-you", component: ThankYou },
		// { url: "terms-conditions", component: Terms },
		// { url: "terms-and-conditions", component: Terms },
		{ url: "pre-order-agreement-and-privacy-policy", component: Home },
	];

	return (
		<>
			<div
				id={`${!pagePath ? "main-wrapper" : ""}`}
				className={`${!pagePath ? "show menu-toggle" : "mh100vh"}`}
			>
				{!pagePath && (
					<Nav
						onClick={() => setActiveEvent(!activeEvent)}
						activeEvent={activeEvent}
						onClick2={() => setActiveEvent(false)}
						onClick3={() => setActiveEvent(true)}
						// onClick
					/>
				)}
				<div
					className={`${!path && activeEvent ? "rightside-event" : ""} ${
						!pagePath ? "content-body" : ""
					}`}
				>
					<div
						className={`${
							!pagePath && !iframeRoutes.some((route) => route.includes(path))
								? "container-fluid"
								: ""
						}`}
						style={{ minHeight: window.screen.height - 60 }}
					>
						<Switch>
							<Route
								exact
								path="/"
								render={() => <Redirect to="/dashboard" />}
							/>
							{routes.map((data, i) => (
								<Route
									key={i}
									exact
									path={`/${data.url}`}
									component={data.component}
								/>
							))}
						</Switch>
					</div>
				</div>
				{!pagePath && <Footer />}
			</div>
			<ScrollToTop />
		</>
	);
};

export default Markup;
